module.exports = __webpack_public_path__ + "img/friend.0d3b66eb.png";